import { Icon } from '@iconify/react';

const iconMap = {
  'chart-bar': 'ph:chart-bar-fill',
  'cart-shopping': 'fa6-solid:cart-shopping',
  comments: 'fa6-solid:comments',
  storefront: 'ph:storefront-fill',
  gear: 'fa6-solid:gear',
  users: 'fa6-solid:users',
  truck: 'fa6-solid:truck',
  user: 'ph:user-fill',
  'map-trifold': 'ph:map-trifold-fill',
  table: 'fa6-solid:table',
  'dollar-sign': 'fa6-solid:dollar-sign',
  'git-fork': 'ph:git-fork-fill',
  megaphone: 'ph:megaphone-fill',
  'boxes-stacked': 'fa6-solid:boxes-stacked',
  tag: 'ph:tag-fill',
  'chart-pie': 'fa6-solid:chart-pie',
  prohibit: 'ph:prohibit-fill',
  'thumbs-up': 'ph:thumbs-up-fill',
  wrench: 'fa6-solid:wrench',
};

export const getIconComponent = (iconName) => {
  const iconId = iconMap[iconName];
  if (!iconId) return null;
  return (props) => <Icon icon={iconId} {...props} />;
};

export const SignOutIcon = (props) => (
  <Icon icon='fa6-solid:arrow-right-from-bracket' {...props} />
);
export const CaretDownIcon = (props) => (
  <Icon icon='ph:caret-down-fill' {...props} />
);
